// Larguras da sidebar de contexto (aberta / recolhida). Compartilhadas entre a
// casca (sidebar-shell) e o shell (margin-left do conteúdo) para não duplicar
// o valor em dois lugares.
export const SIDEBAR_WIDTH_OPEN = 264
export const SIDEBAR_WIDTH_SMALL = 84
